import { CSSProperties } from "react";

export default {
    header: {
        zIndex: 2,
        textAlign: "center"
    } as CSSProperties
};
